import React from "react";

import type { FiltersState } from "../../../common/hooks/useFilters";
import FilterBar from "../../../components/FilterBar";
import type { FilterNames } from "../../../types/filter";
import type { RankedCallsParams } from "../hooks/useRankedCallsMode";
import RankedCallsContextBanner from "./RankedCallsContextBanner";

interface ExploreHeaderProps {
  rankedCallsParams: RankedCallsParams | null;
  filters: FiltersState;
  rowCount: number;
  onFilterChange: (name: FilterNames, value: string) => void;
  onScoreRangeChange: (value: [number, number]) => void;
  onRefresh: () => void;
  onExpandedChange: (expanded: boolean) => void;
  onReopenWizard: () => void;
}

const FILTER_BAR_CONFIG = {
  timeRange: true,
  sentiment: true,
  relevance: true,
  risk: true,
  protocol: true,
  user: true,
  scoreRange: true,
  processDecision: true,
  callType: true,
  search: true
};

const ExploreHeader = ({
  rankedCallsParams,
  filters,
  rowCount,
  onFilterChange,
  onScoreRangeChange,
  onRefresh,
  onExpandedChange,
  onReopenWizard
}: ExploreHeaderProps): React.ReactElement => {
  if (rankedCallsParams) {
    return (
      <RankedCallsContextBanner
        order={rankedCallsParams.order}
        lens={rankedCallsParams.lens}
        attribute={rankedCallsParams.attribute}
        count={rankedCallsParams.count}
        timeRange={rankedCallsParams.timeRange}
        agent={rankedCallsParams.agent}
        totalResults={rowCount}
        onReopenWizard={onReopenWizard}
        onRefresh={onRefresh}
      />
    );
  }

  return (
    <FilterBar
      title="Artifact Explorer"
      timeRange={filters.timeRange}
      sentiment={filters.sentiment}
      relevance={filters.relevance}
      risk={filters.risk}
      protocol={filters.protocol}
      user={filters.user}
      processDecision={filters.processDecision}
      callType={filters.callType}
      searchTerm={filters.search}
      scoreRange={filters.scoreRange}
      totalConversations={rowCount}
      onFilterChange={onFilterChange}
      onScoreRangeChange={onScoreRangeChange}
      onRefresh={onRefresh}
      onExpandedChange={onExpandedChange}
      showFilters={FILTER_BAR_CONFIG}
    />
  );
};

export default ExploreHeader;
